export enum CollateralServiceErrorCode {
  GENERAL,
}

export interface CollateralFailure {
  message: string
}

export interface CollateralSearchParams {
  searchfield: string
  searchflags: string
  searchvalue: string
  Floor?: string
  AptNo?: string
  nodeid?: number
  StateID?: number
  Visa?: 0 | 1 | 2
  instanceName?: string
}

export interface HypothecCollateral {}

export type HypothecCollateralsRequestServerData = HypothecCollateral | HypothecCollateral[]

export interface CollateralViewParams {
  CollateralID: number | string
  HashSum_CollateralID_: string
  page?: string
  action?: string
  CCY?: string
  ProductID?: number | string
  HashSum_ProductID_?: string
}

export interface CollateralAddParams {
  action: 'add' | 'edit' | 'delete'

  ClientID: number | string
  HashSum_ClientID_: string

  CollateralID?: number
  HashSum_CollateralID_?: string

  WHLSessionID?: number | string
  HashSum_WHLSessionID_?: string

  StartDate?: string
  TypeID?: number | string
  TypeID2?: number | string
  CityID?: number | string
  CCY?: string
  LiquidPrice?: number | string
  MarketPrice?: number | string
  InsuranceSum?: number | string
  InsuranceCCY?: string
  InsuranceDate?: string
  InsuranceExpire?: string
  InsuranceCompanyID?: number | string
  Address?: string
  Address_ALT?: string
  Description?: string
  Description_ALT?: string
  Comment?: string
  Comment_ALT?: string
  CField1?: string
  CField2?: string
  CField3?: string
  CField4?: string
  ProductID?: number | string
  NodeID?: number | string
  DynFieldData?: string
  HashSum_ProductID_?: number
  FrameDetails?: string
  ReqFieldGroupID?: number | string
}

export enum CollateralOperActions {
  ACCESSPERMADD = 'accesspermadd',
  ACCESSPERMDELETE = 'accesspermdelete',
  VISA = 'visa',
  VISAUNDO = 'visaundo',
  AGREEMENTNUMBERUPDATE = 'agreementnumberupdate',
  STATEUPDATE = 'stateupdate',
  DETAILSSTATEUPDATE = 'detailstateupdate',
  UPDATEDESC = 'updatedesc',
  STATECLEAR = 'stateclear',
}

export type CollateralAddPermissionParams = {
  CollateralID: number
  HashSum_CollateralID_: string
  ID: number | string
}

export type CollateralDeletePermissionParams = CollateralAddPermissionParams

export interface CollateralOperationsParams {
  ID: number | string
  CollateralID: number | string
  HashSum_CollateralID_: string
  action: string
}

export type CollateralVisaParams = {
  CollateralID: number | string
  HashSum_CollateralID_: string
}

export type CollateralUndoVisaParams = CollateralVisaParams

export interface CollateralUpdateAgreementNumberParams {
  CollateralID: number | string
  HashSum_CollateralID_: string
  AgreementNo: number | string
}

export interface CollateralEditStateParams {
  CollateralID: number | string
  HashSum_CollateralID_: string
  StateID: number | string
}

export interface CollateralEditDetailStateParams {
  CollateralID: number | string
  HashSum_CollateralID_: string
  DetailID: number | string
  HashSum_DetailID_: string
  DetailStateID: number | string
}

export interface CollateralUpdateDescParams {
  CollateralID: number | string
  HashSum_CollateralID_: string
  Description: string
}

export type CollateralOperParams = {
  action: string
} & (
  | CollateralAddPermissionParams
  | CollateralDeletePermissionParams
  | CollateralOperationsParams
  | CollateralVisaParams
  | CollateralUndoVisaParams
  | CollateralUpdateAgreementNumberParams
  | CollateralEditStateParams
  | CollateralEditDetailStateParams
  | CollateralUpdateDescParams
)

export enum CollateralManagementViewActions {
  VIEWSESSIONS = 'viewsessions',
  PRINTSESSION = 'printsession',
  VIEWWORKLIST = 'viewworklist',
}

export type CollateralManagementViewSessionsParams = {
  SessionDate: string
}

export type CollateralManagementPrintSessionsParams = {
  CMSessionID: number | string
  HashSum_CMSessionID_: string
}

export type CollateralManagementViewWorklistParams = CollateralManagementPrintSessionsParams

export type CollateralManagementViewParams = {
  action: string
} & (
  | CollateralManagementViewSessionsParams
  | CollateralManagementPrintSessionsParams
  | CollateralManagementViewWorklistParams
  | CollateralManagementPrintSessionsParams
)

export enum CollateralManagementOperActions {
  LOADWORKLIST = 'loadworklist',
  CLEARWORKLIST = 'clearworklist',
  ADDWORKLIST = 'addworklist',
  DELETEWORKLIST = 'deleteworklist',
  PROCESSWORKLIST = 'processworklist',
}

export type CollateralManagementLoadWorklistParams = {
  CMSessionID: number | string
  HashSum_CMSessionID_: string
}

export type CollateralManagementClearWorklistParams = CollateralManagementLoadWorklistParams

export type CollateralManagementAddWorklistParams = CollateralManagementLoadWorklistParams & {
  CollateralID: number | string
  HashSum_CollateralID_: string
}

export type CollateralManagementDeleteWorklistParams = CollateralManagementLoadWorklistParams & {
  ID: number | string
}

export type CollateralManagementProcessWorklistParams = CollateralManagementLoadWorklistParams & {
  StateID: number | string
  LocationID: number | string
}

export type CollateralManagementOperParams = {
  action: string
} & (
  | CollateralManagementLoadWorklistParams
  | CollateralManagementClearWorklistParams
  | CollateralManagementAddWorklistParams
  | CollateralManagementDeleteWorklistParams
  | CollateralManagementProcessWorklistParams
)
